<div class="tooltip" [appTooltip]="show" [refEl]="elementRef" >
    {{ text | translate }}
    <div class="tooltip__arrow"></div>
</div>
